export default __webpack_public_path__ + "static/media/07.214ad276.png";